// extracted by mini-css-extract-plugin
export default {"backgroundImage":"countryBackgroundImage-module__backgroundImage__w88VB","imageOverlay":"countryBackgroundImage-module__imageOverlay__2x8Zj"};